<template>
  <v-btn
    color="pink"
    dark
    absolute
    bottom
    elevation="0"
    right
    fab
    x-small
    style="margin-bottom:120px"
    :style="{ marginRight: `${margin}px` }"
    @click="handleRedirect"
  >
    <v-icon>mdi-plus</v-icon>
  </v-btn>
</template>
<script>
export default {
  props: {
    margin: {
      type: Number,
      default: 0,
    },
    domain: {
      type: String,
      required: true,
    },
  },
  methods: {
    handleRedirect () {
      const url = `http://${this.domain}.dtouch.es/#/totem/?touchPublic=true`
      location.href = url
    },
  }
}
</script>
